import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import { getApprovalByType, hasSign, renderSign } from './utils/PtwCommonUtils.tsx';

interface IProps {
  formCode?: string;
  itemData?: any;
}

const View = (props: IProps) => {
  const approvalList = props.itemData?.approvalMVOList;
  const issuePerforming = getApprovalByType(approvalList, 'ISSUE', 1);
  const issueReviewing = getApprovalByType(approvalList, 'ISSUE', 2);
  const issueApproval = getApprovalByType(approvalList, 'ISSUE', 3);
  const issueCoordinator = getApprovalByType(approvalList, 'ISSUE', 4);
  const issueAgt = getApprovalByType(approvalList, 'ISSUE', 5);

  return (
    <div>
      <table className={'preview-table preview-bottom-border'}>
        <colgroup>
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
        </colgroup>
        <tbody>
          <tr>
            <th colSpan={8} style={{ backgroundColor: '#FFF2CC' }}>
              ISSUE
            </th>
            <th colSpan={2} style={{ backgroundColor: '#00B050' }}>
              OPEN at Site
            </th>
          </tr>
          <tr>
            <th colSpan={2}>PERFORMING AUTHORITY</th>
            <th colSpan={2}>REVIEWING AUTHORITY</th>
            <th colSpan={2}>APPROVAL AUTHORITY</th>
            <th colSpan={2}>SE&A PTW COORDINATOR</th>
            <th colSpan={2} style={{ backgroundColor: '#8EA9DB' }}>
              SE&A AGT
            </th>
          </tr>
          <tr>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
            <th style={{ backgroundColor: '#8EA9DB' }}>NAME</th>
            <th style={{ backgroundColor: '#8EA9DB' }}>SIGN</th>
          </tr>
          <tr>
            <td className="saf-td-center">
              &nbsp;
              {hasSign(issuePerforming) ? issuePerforming.userNm : ''}&nbsp;
            </td>
            <td className="saf-td-center">{renderSign(issuePerforming)}</td>
            <td className="saf-td-center">
              {hasSign(issueReviewing) ? issueReviewing.userNm : ''}
            </td>
            <td className="saf-td-center">{renderSign(issueReviewing)}</td>
            <td className="saf-td-center">{hasSign(issueApproval) ? issueApproval.userNm : ''}</td>
            <td className="saf-td-center">{renderSign(issueApproval)}</td>
            <td className="saf-td-center">
              {hasSign(issueCoordinator) ? issueCoordinator.userNm : ''}
            </td>
            <td className="saf-td-center">{renderSign(issueCoordinator)}</td>
            <td className="saf-td-center">{hasSign(issueAgt) ? issueAgt.userNm : ''}</td>
            <td className="saf-td-center">{renderSign(issueAgt)}</td>
          </tr>
        </tbody>
      </table>
      <table className={'preview-table preview-bottom-border'}>
        <colgroup>
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
        </colgroup>
        <tbody>
          <tr>
            <td colSpan={10} align={'left'}>
              AGT/ES (Use Record of Additional Gas Testing Form - 8 hour)
            </td>
          </tr>
          <tr>
            <th>Material</th>
            <th>Combustible</th>
            <th>Oxygen</th>
            <th>H2S</th>
            <th>CO</th>
            <th>Others</th>
            <th rowSpan={2}>DATE</th>
            <th rowSpan={2}>TIME</th>
            <th rowSpan={2}>NAME</th>
            <th rowSpan={2}>SIGNATURE</th>
          </tr>
          <tr>
            <th>PEL</th>
            <th>
              <span style={{ color: '#FF0000' }}>HW</span> &lt;1% /{' '}
              <span style={{ color: '#00B0F0' }}>CW</span> &lt;10%
            </th>
            <th>19.5 % - 23.5%</th>
            <th>≤ 10 ppm</th>
            <th>≤ 10 ppm</th>
            <th>if required</th>
          </tr>
          <tr>
            <th>Testing before Work</th>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <th rowSpan={3}>Testing during Work</th>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
      <table className={'preview-table preview-bottom-border'}>
        <colgroup>
          <col width={'20%'} />
          <col width={'20%'} />
          <col width={'20%'} />
          <col width={'20%'} />
          <col width={'20%'} />
        </colgroup>
        <tbody>
          <tr>
            <td colSpan={5}>Re-validation (Only valid for 4 hours of extended working time)</td>
          </tr>
          <tr>
            <th>Date</th>
            <th>Time</th>
            <th>Entry Supervisor Name</th>
            <th>Signature</th>
            <th>Remark</th>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
      <table className={'preview-table'}>
        <colgroup>
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
        </colgroup>
        <tbody>
          <tr>
            <td colSpan={10}>
              AGT/ES (Use Record of Additional Gas Testing Form - Additional 4 hour)
            </td>
          </tr>
          <tr>
            <th>Material</th>
            <th>Combustible</th>
            <th>Oxygen</th>
            <th>H2S</th>
            <th>CO</th>
            <th>Others</th>
            <th rowSpan={2}>DATE</th>
            <th rowSpan={2}>TIME</th>
            <th rowSpan={2}>NAME</th>
            <th rowSpan={2}>SIGNATURE</th>
          </tr>
          <tr>
            <th>PEL</th>
            <th>
              <span style={{ color: '#FF0000' }}>HW</span> &lt;1% /{' '}
              <span style={{ color: '#00B0F0' }}>CW</span> &lt;10%
            </th>
            <th>19.5 % - 23.5%</th>
            <th>≤ 10 ppm</th>
            <th>≤ 10 ppm</th>
            <th>if required</th>
          </tr>
          <tr>
            <td align={'center'} style={{ whiteSpace: 'nowrap' }}>
              Testing before Work
            </td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td colSpan={8} align={'right'}>
              <b>Verification by SE&A AGT</b>
            </td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default View;
